import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthBypassGuard } from '@lib-core/auth/guards/auth-bypass.guard';
import { AuthGuard } from '@lib-core/auth/guards/auth.guard';
import { FallbackGuard } from '@lib-core/fallback/guards/fallback.guard';
import { AppGuard } from '@lib-core/global/guards/app.guard';
import { MaintenanceGuard } from '@lib-core/maintenance/guards/maintenance.guard';

import { LayoutBlankComponent } from '@app-frontoffice/layout/components/layout-blank/layout-blank.component';
import { LayoutExternalComponent } from '@app-frontoffice/layout/components/layout-external/layout-external.component';
import { FallbackComponent } from '@lib-core/fallback/fallback.component';
import { LayoutCoreComponent } from '@lib-core/layout/components/layout-core/layout-core.component';
import { LayoutEmbeddedComponent } from '@app-embedded/layout/components/layout-embedded/layout-embedded.component';
import { languageCheckGuard } from '@lib-shared/lang/guards/language-check.guard';

export const routes: Routes = [
  {
    path: '',
    component: LayoutCoreComponent,
    children: [
      // core-fallback
      {
        path: 'fallback',
        canActivate: [FallbackGuard, AuthBypassGuard],
        component: LayoutExternalComponent,
        children: [
          {
            path: '',
            component: FallbackComponent,
          },
        ],
      },

      // core-error
      {
        path: 'error',
        component: LayoutExternalComponent,
        canActivate: [MaintenanceGuard, AuthBypassGuard],
        children: [
          {
            path: '',
            loadChildren: () => import('./lib-core/error/error.module').then(mod => mod.ErrorModule),
          },
        ],
      },

      // core-login
      {
        path: 'login',
        component: LayoutBlankComponent,
        canActivate: [MaintenanceGuard, AuthGuard, AppGuard],
        data: {
          app: ['backoffice', 'frontoffice'],
        },
        children: [
          {
            path: '',
            loadChildren: () => import('./lib-core/login/login-lazy.module').then(mod => mod.LoginLazyModule),
          },
        ],
      },

      // app-embedded
      {
        path: 'embedded',
        canActivate: [MaintenanceGuard, AuthBypassGuard, AppGuard],
        data: {
          runLoginInComplete: true,
          app: ['embedded'],
        },
        loadChildren: () =>
          import('./app-embedded/app-embedded-lazy.module').then(mod => mod.AppEmbeddedModuleLazyModule),
      },

      // app-promotion
      {
        path: ':lang/promotion',
        canActivate: [languageCheckGuard],
        children: [
          {
            path: '',
            canActivate: [MaintenanceGuard, AuthBypassGuard, AppGuard],
            data: {
              runLoginInComplete: true,
              app: ['embedded'],
            },
            children: [
              {
                path: '',
                component: LayoutEmbeddedComponent,
                children: [
                  {
                    path: '',
                    loadChildren: () =>
                      import('./app-embedded/modules/promo/promo-lazy.module').then(mod => mod.PromoLazyModule),
                  },
                ],
              },
            ],
          },
        ],
      },

      // app-backoffice
      {
        path: 'backoffice',
        canActivate: [MaintenanceGuard, AuthGuard, AppGuard],
        data: {
          app: ['backoffice'],
        },
        loadChildren: () =>
          import('./app-backoffice/app-backoffice-lazy.module').then(mod => mod.AppBackofficeModuleLazyModule),
      },

      // choose-app
      {
        path: 'app-choose',
        component: LayoutBlankComponent,
        canActivate: [MaintenanceGuard, AuthGuard, AppGuard],
        data: {
          app: ['backoffice', 'frontoffice'],
        },
        loadChildren: () => import('./app-choose/app-choose-lazy.module').then(mod => mod.AppChooseModuleLazyModule),
      },

      // app-frontoffice
      {
        path: '',
        canActivate: [MaintenanceGuard, AuthGuard, AppGuard],
        data: {
          app: ['frontoffice'],
        },
        loadChildren: () =>
          import('./app-frontoffice/app-frontoffice-lazy.module').then(mod => mod.AppFrontofficeModuleLazyModule),
      },

      // fallback
      {
        path: '**',
        redirectTo: 'login',
      },
    ],
  },
];
